import React, { createContext, useState, useContext } from "react";
import { PaginationConfig } from "@beeldit/core/models/PaginationConfig.interface";
import { TableData } from "@beeldit/core/models/TableData.interface";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";

interface ListActionContextType {
  filtersLoaded: boolean;
  setFiltersLoaded: (filtersLoaded: boolean) => void;
  tableFilters: any;
  setTableFilters: (tableFilters: any) => void;
  paginationConfig: PaginationConfig;
  setPaginationConfig: (paginationConfig: PaginationConfig) => void;
  tableData: TableData;
  setTableData: (tableData: TableData) => void;
  orderBy: string | null;
  setOrderBy: (orderBy: string | null) => void;  
  tableConfig: FinalTableConfig;
  setTableConfig: (tableConfig: FinalTableConfig) => void;
}

export const ListActionContext = createContext<ListActionContextType>({
  filtersLoaded: false,
  setFiltersLoaded: () => {},
  tableFilters: {},
  setTableFilters: () => {},
  paginationConfig: { page: 1, elementsPerPage: 20 },
  setPaginationConfig: () => {},
  tableData: { elements: [] },
  setTableData: () => {},
  orderBy: null,
  setOrderBy: () => {},
  tableConfig: { index: () => {}, actions: [], rowActions: [], rowConfiguration: {}, columns: [], pagination: { enabled: false, back: false }},
  setTableConfig: () => {},
});

interface ListActionProviderProps {
  children: React.ReactNode;
}

export const ListActionProvider: React.FC<ListActionProviderProps> = ({
  children,
}) => {
  const [filtersLoaded, setFiltersLoaded] = useState(false);
  const [tableFilters, setTableFilters] = useState({});
  const [paginationConfig, setPaginationConfig] = useState<PaginationConfig>({
    page: 1,
    elementsPerPage: 20,
  });
  const [tableData, setTableData] = useState<TableData>({ elements: [] });
  const [orderBy, setOrderBy] = useState<string | null>('+name->es');
  const [tableConfig, setTableConfig] = useState<FinalTableConfig>({
    index: () => {},
    actions: [],
    rowActions: [],
    rowConfiguration: {},
    columns: [],

    pagination: {
      enabled: false,
      back: false,
    },
  });

  const value = {
    filtersLoaded,
    setFiltersLoaded,
    tableFilters,
    setTableFilters,
    paginationConfig,
    setPaginationConfig,
    tableData,
    setTableData,
    orderBy,
    setOrderBy,
    tableConfig,
    setTableConfig,
  };
  return (
    <ListActionContext.Provider value={value}>
      {children}
    </ListActionContext.Provider>
  );
};
